<template>
    <v-container class="pa-0">
        <v-row class="justify-center ">
            <v-alert min-width="100%" dense type="info" outlined :color="isBackorder? 'warning' : 'error'" style="font-size:14px;"
                >
                <div class="d-flex justify-space-between align-center">
                <span
                    >
                    <div v-if="isBackorder" class="d-flex align-center">
                    <TranslatableStringComponent
                        :tstring="{ string: 'backOrderItemsAlert'}"
                    /> 
                    <nuxt-link :to="
                        getStaticLocalePath(backOrderRoute)
                    " class="ml-1">{{backOrderDocNo}}</nuxt-link>
                    </div>
                    <TranslatableStringComponent
                    v-else
                        :tstring="{ string: 'itemsRemovedFromOrder' }"
                    />
                    </span
                >
                <v-btn
                    :color="isBackorder? 'warning' : 'error'"
                    plain
                    text
                    small
                    @click="$emit('toggleShowItems', !showItems)"
                    ><u
                        ><TranslatableStringComponent
                            v-if="!showItems"
                            :tstring="{ string: 'view' }"
                        />
                        <TranslatableStringComponent
                            v-else
                            :tstring="{ string: 'hide' }"
                        /> </u
                ></v-btn>
                </div>
            </v-alert>
        </v-row>
        <v-expand-transition>
            <div v-if="showItems">
                <v-row
                    v-for="item in items"
                    :key="item.id"
                    style="opacity: 0.5"
                >
                    <v-col cols="6" class="pa-sm-2">
                        <div class="mb-2 d-flex">
                            <span class="font-weight-bold">
                                <TranslatableStringComponent
                                    :tstring="{ string: 'partNo' }"
                                />:
                            </span>
                            <div class="product-pn-link ml-1">
                                {{ item.itemName }}
                            </div>
                        </div>

                        <div>
                            <span class="font-weight-bold">
                                <TranslatableStringComponent
                                    :tstring="{ string: 'partName' }"
                                />:
                            </span>
                            <div class="product-name-link ml-1">
                                {{ item.itemDescription }}
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="2" class="pa-sm-2 text-right">
                        {{ item.orderLineQty }}
                    </v-col>
                    <v-col cols="2" class="pa-sm-2 text-right">
                        {{ dollars(item.orderLineActualPrice) }}
                    </v-col>
                    <v-col cols="2" class="pa-sm-2 text-right">
                        {{ dollars(item.orderLineTotal) }}
                    </v-col>
                    <v-col cols="12"><v-divider></v-divider></v-col>
                    <!-- <v-row>
                                                <v-col><v-divider></v-divider></v-col>
                                            </v-row> -->
                </v-row>
            </div>
        </v-expand-transition>
    </v-container>
</template>
<script>
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

export default {
    name: 'OrderSummaryBackorderAlert',
    props: {
        items: {
            type: Array,
            default: null,
        },
        showItems: {
            type: Boolean,
            default: false,
        },
        boid: {
            type: Number,
            default: null,
        },
        isBackorder: {
            type: Boolean,
            default: false,
        },
        backOrderDocNo: {
            type: String,
            default: '',
        },
    },
    components: {
        TranslatableStringComponent,
    },
    computed: {
        backOrderRoute() {
            let query = { orderNo: this.$route.query.orderNo, boid: this.boid }
            return {
                type: 'page',
                slugName: 'order-details',
                query,
            }
        }
    }
}
</script>
